// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__25Ko3","content":"styles_content__3jZ6l","checkbox":"styles_checkbox__rRYex","checkboxLabel":"styles_checkboxLabel__27jUS"};